
<template>
  <div class="container">
    <div class="row">
      <div class="col-lg">
        <!--<h1>MPR Upload</h1>-->
        <img alt="logo" src="../assets/logo.svg" style="width:250px;margin-top:156px;margin-bottom:10px;" >
      </div>
    </div>
    <div class="row">
      <!-- Buffer -->
      <div class="col"></div>

      <!-- File upload interface -->
      <div id="fileDrop" :hidden="isFileDropHidden" class="col-6 card bg-white" v-cloak @drop.prevent="dropFile" @dragover.prevent>
          <svg class="box__icon" xmlns="http://www.w3.org/2000/svg" width="50" height="43" viewBox="0 0 50 43">
            <path d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"></path>
          </svg>
          <input id="file" :hidden="true" @change="handleFile" class="custom-input" type="file" accept="*">
          <label for="file" v-html="fileName"></label>
          <div id="uploadControl" class="uploadControl">
            <button class="btn btn-primary" style="width: 100px;" :disabled="!hasSelectedFile" @click="startIngestion">Upload</button>
          </div>
      </div>

      <!-- Progress interface -->
      <div id="uploadProgress" :hidden="isUploadProgressHidden" class="col-6 card bg-white">
          <!-- In-progress notification -->
          <div class="loading" :hidden="isLoadingHidden">
            <span>In progress.. <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i></span>
          </div>
          <!-- Error notifications -->
          <div id="uploadOutput" :hidden="isStatusHidden" class="uploadOutput alert" v-bind:class="{ 'alert-danger': isError, 'alert-success': isSuccess }" role="alert" v-html="statusLog"></div>
          <!-- Step progress -->
          <div style="display:block;">
            <step-progress style="margin-bottom:60px;"
              :steps="mySteps"
              :current-step="currentStep"
              :active-color="stepActiveColor"
              :passive-color="stepPassiveColor"
              :active-thickness="stepThickness"
              :passive-thickness="stepThickness"
              :line-thickness="stepThickness"
              icon-class="fa fa-check">
            </step-progress>
          </div>
      </div>

      <!-- Buffer -->
      <div class="col"></div>
    </div>
  </div>
</template>

<style>
.loading {
  font-size: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.card {
  border: 1px dashed #999; min-height: 150px; text-align: center; padding-left:50px; padding-right: 50px;
}
.box__icon {
  width: 100%; height: 80px; fill: #002776; opacity: 0.5; display: block; margin-bottom: 10px; margin-top: 20px;
}
.uploadControl {
  width: 100%; fill: #92b0b3; display: block; margin-bottom: 20px; margin-top: 20px;
}
.uploadOutput {
  margin-top: 20px;
  text-align: left;
}
.btn-primary {
  background-color: #002776 !important;
  border-color: #002776 !important;
}
.btn-primary:disabled {
  opacity: 0.3 !important;
}
</style>

<script>
import API from '@aws-amplify/api';
import axios from 'axios';
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';
import AmplifyStore from '../store';

API.configure();

export default {
  name: 'Upload',

  data:  () => {
    return {
      actualFile: '',
      file: '',
      fileName: '<strong>Choose a file</strong> or drag it here.',
      fileType: '',
      template: '',
      jobNum: '',
      month: '',
      year: '',
      pid: '',
      statusLog: '',
      timer: '',
      timerCount: 0,
      isStatusVisible: false,
      isUploadDisabled: true,
      isFileDropHidden: false,         // DEFAULT: False
      isUploadProgressHidden: true,  // DEFAULT: True
      isLoadingHidden: false,         // DEFAULT: False
      isStatusHidden: true,           // DEFAULT: True
      isError: false,
      isSuccess: false,

      mySteps: ['Uploading', 'Processing', 'Done'],
      currentStep: 0,
      stepActiveColor: "#002776",
      stepPassiveColor: "grey",
      stepThickness: 3,

      genericError: {
        "records": {
          'Items': [
            {"output": {"L": [{"S": "Failed to receive a success reponse from server. Please try again or <a href='mailto:servicedesk@watpac.com.au'>contact support</a> if errors persist."}]},
            "success": {"BOOL": false}}
          ],
          'Count': 1
        }
      }
    };
  },
  components: {
    'step-progress': StepProgress
  },
  methods: {
    reload: function() {
      location.reload();
    },
    dropFile: function(e) {
      let droppedFiles = e.dataTransfer.files;
      if(!droppedFiles) return;
      const selectedFile = droppedFiles[0];
      this.actualFile = selectedFile;
      this.fileName = selectedFile.name;
      this.fileType = selectedFile.type;
      this.extractFileTags();
    },
    handleFile: function(e) {
      const selectedFile = e.target.files[0];
      this.actualFile = selectedFile;
      this.fileName = selectedFile.name;
      this.fileType = selectedFile.type;
      this.extractFileTags();
    },
    extractFileTags: function() {
      let fn = this.fileName;
      let fileExt = '';

      if (this.fileName.includes('.')) {
        fn = this.fileName.split('.')[0];
        fileExt = this.fileName.split('.')[1].toLowerCase();
      }

      // Check extension: xlsm and jpg
      if (!fileExt || ['xlsm', 'jpg'].indexOf(fileExt) < 0) {
        this.actualFile = "";
        this.fileName = "<div style='margin-top:20px; margin-bottom:20px; padding: 10px;' class='alert-danger'><strong>Error:</strong> Please upload a xlsm file or a jpg image with format:<br>'MPR - [Job number] - [Month] [Year]'.</div><strong>Choose a file</strong> or drag it here.";
        this.fileType = "";
      } else if (this.checkFileNamingIsValid(fn)) {
        fn = fn.split(' - ');
        this.template = fn[0].trim();
        this.jobNum = fn[1].trim();
        this.month = fn[2].trim().split(' ')[0];
        this.year = fn[2].trim().split(' ')[1];

        // Only enable to upload file from the 22nd of last month to the 22nd of this month.
        const today = new Date();
        const day = today.getDate();
        let year = today.getFullYear();        
        let month = today.getMonth();
        month = day > 22 ? month : month - 1;        
        if(month < 0)
        {
          month = 11;
          year = year - 1;
        }
        let monthName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][month];        

        if (this.year !== String(year) || this.month !== monthName) {
          this.actualFile = "";
          this.fileName = `<div style='margin-top:20px; margin-bottom:20px; padding: 10px;' class='alert-danger'><strong>Error:</strong> Please upload the file for '<b>${monthName} ${year}</b>'.</div><strong>Choose a file</strong> or drag it here.`;
          this.fileType = "";
        }
      } else {
        this.actualFile = "";
        this.fileName = "<div style='margin-top:20px; margin-bottom:20px; padding: 10px;' class='alert-danger'><strong>Error:</strong> Please use the file naming format of:<br>'MPR - [Job number] - [Month] [Year]'.</div><strong>Choose a file</strong> or drag it here.";
        this.fileType = "";
      }
    },
    checkFileNamingIsValid(fn) {
      const pattern = /(MPR|HSEQ|PSR) - [A-Z0-9]\w+ - (January|February|March|April|May|June|July|September|August|October|November|December) 20[1-2][0-9]/g;
      return fn.match(pattern);
    },
    startIngestion: function() {
      this.isFileDropHidden = true;
      this.isUploadProgressHidden = false;
      this.getPresignedURL();
    },
    getPresignedURL: function() {
      const apiName = 'mprAPI';
      const path = '/getPresignedURL'; 
      const request = {
          headers: {},
          body: {
            name: this.fileName,
            fileType: this.fileType
          }
      };

      API
        .post(apiName, path, request)
        .then(response => {
          this.pid = response.pid;
          this.uploadPSU(response.url, response.name);
        })
        .catch(() => {
          this.updateStatusLog(this.genericError);
        });
    },
    uploadPSU: function(url) {
      const headers = {
        'Content-Type': this.fileType,
        'x-amz-tagging': `template=${this.template}&job_num=${this.jobNum}&year=${this.year}&month=${this.month}`
      };
      axios
        .put(url, this.actualFile, {headers: headers})
        .then(() => {
          this.timer = setInterval(this.checkIngestionProgress, 5000)  // Start log refresh timer
          this.currentStep = 1;
        })
        .catch(() => {
        })
    },
    checkIngestionProgress: function() {
      const apiName = 'mprAPI';
      const path = `/checkStatus`;
      const request = {
        'queryStringParameters': {
          'pid': this.pid
        }
      };

      // Increment timer count (5s intervals)
      this.timerCount++;

      API
        .get(apiName, path, request)
        .then(response => {
          // Check if we've received any records
          if (("records" in response) && (response.records.Count > 0)) {
            // Cancel log refresh timer
            clearInterval(this.timer);
            // Display output
            this.updateStatusLog(response);
          } else {
            // Check if timer is exhausted (~2m)
            if (this.timerCount >= 24) {
              // Cancel log refresh timer
              clearInterval(this.timer);
              // Display error output
              this.updateStatusLog(this.genericError);
            }
          }
        })
        .catch(() => {
          this.updateStatusLog(this.genericError);
        });
    },
    updateStatusLog: function(r) {
      let s = ""
      if (r.records.Count > 0) {

        this.isLoadingHidden = true;
        this.isStatusHidden = false;
        this.currentStep = 2;

        try {
          let success = r.records.Items[0].success.BOOL;
          //let success = true;
          
          if (success) {
            this.isSuccess = true;
            this.currentStep = 3;
            s = `<strong>${this.fileName} was successfully uploaded!</strong><br>`;
            s += "<p><a href='javascript:location.reload();'>Click here to upload another file</a></p>";
          } else {
            this.isError = true;
            s += "<strong>Processing was unsuccessful due to the following errors:</strong>";
            s += "<ul>";
            for (const item of r.records.Items[0].output.L) {
              s += `<li>${item.S}</li>`;
            }
            s += "</ul>";
            s += "<a href='javascript:location.reload();'>Click here to upload another file</a>"
          }
        }
        catch (err) {
          s = "<strong>An unknown failure occurred while processing. Please <a href='mailto:servicedesk@watpac.com.au'>contact support</a>.</strong><br><a href='javascript:location.reload();'>Click here to go back.</a>"
        }
      }
      this.statusLog = s
    }
  },
  computed: {
    user: function() { 
      return AmplifyStore.state.user 
    },
    hasSelectedFile: function() {
      if (this.actualFile) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>
